import miseAJourCommentaire from '@/services/devisCommandes/miseAJourCommentaire';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import ordreAddInRegroupement from '@/services/devisCommandes/ordreAddInRegroupement';
import copieReferencePersonnalise
  from '@/services/devisCommandes/regroupementPersonnalise/copieReferencePersonnalise';

function genererCommentaireVente(ligneCommande, commentaire) {
  const ordre = ordreAddInRegroupement(ligneCommande);
  const nouvelleLigne = genererLigneCommande(ordre / 100);
  miseAJourCommentaire(nouvelleLigne);
  copieReferencePersonnalise([nouvelleLigne], ligneCommande);
  nouvelleLigne.libelle = commentaire;
  return nouvelleLigne;
}
export default function genererCommentaireVenteForLigne(produit, ligneCommande, lignes) {
  const commentaire = produit?.produitEnfant?.commentaireVente || produit.commentaireVente;
  if (!commentaire) return;
  const ligne = genererCommentaireVente(ligneCommande, commentaire);
  if (lignes) lignes.push(ligne);
  else if (ligneCommande.lignesCommande) {
    ligneCommande.lignesCommande.push(ligne);
  }
}
